import axios from 'axios'
import { ResponseAPIModel } from '../../../../setup/models/ResponseAPIModel'
import { MerchantModel } from '../models/MerchantModel'
import { BankAccountModel } from '../models/BankAccountModel'
import { ContactModel } from '../models/ContactModel'
import { FeePlanModel } from '../models/FeePlanModel'
import { VposModel } from '../models/VposModel'

const API_URL = process.env.REACT_APP_API_URL || '/api'
export const GET_MERCHANT_URL = `${API_URL}/Merchant/GetMerchant`
export const GET_BANKS_URL = `${API_URL}/Merchant/GetBanks`
export const GET_CONTACTS_URL = `${API_URL}/Merchant/GetContacts`
export const GET_FEE_PLAN_URL = `${API_URL}/Merchant/GetMerchantFeePlans`
export const GET_CUSTOMER_FEE_PLAN_URL = `${API_URL}/Merchant/GetMerchantCustomersFeePlans`
export const GET_HASH_PARAM_URL = `${API_URL}/Merchant/GetMerchantHashParam`
export const UPDATE_HASH_PARAM_URL = `${API_URL}/Merchant/UpdateMerchantHashParam`

export function getMerchant() {
    return axios.get<ResponseAPIModel<MerchantModel>>(GET_MERCHANT_URL)
}

export function getHashParam() {
    return axios.get<ResponseAPIModel<string>>(GET_HASH_PARAM_URL)
}

export function updateHashParam() {
    return axios.get<ResponseAPIModel<string>>(UPDATE_HASH_PARAM_URL)
}

export function getBanks() {
    return axios.get<ResponseAPIModel<BankAccountModel[]>>(GET_BANKS_URL)
}

export function getContacts() {
    return axios.get<ResponseAPIModel<ContactModel[]>>(GET_CONTACTS_URL)
}

export function getFeePlan() {
    return axios.get<ResponseAPIModel<FeePlanModel>>(GET_FEE_PLAN_URL)
}

export function getCustomerFeePlan() {
    return axios.get<ResponseAPIModel<VposModel[]>>(GET_CUSTOMER_FEE_PLAN_URL)
}